module.exports = __webpack_public_path__ + "img/hbhy.261667c5.png";